import { createContext, useContext } from 'react';

type FacebookLoginContextState = {
  loginCode: string;
  facebookLoginUrl: string;
};

export const FacebookLoginContext = createContext<FacebookLoginContextState>({
  loginCode: '',
  facebookLoginUrl: '',
});

export const useFacebookLoginContext = () => useContext(FacebookLoginContext);
